import { useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useMutation } from '@apollo/client';
import { notifySuccess } from '../../../../services/notification';
import { CancelIcon, SaveIcon } from '../../../common/icons';
import SpinnerOverlay from '../../../common/spinner/spinner';
import { IHeader } from '../../../../types/infogo';
import HeaderDetails, { HeaderHandler } from './header-details';
import { GET_INFOGO_HEADER_ORGS, UPDATE_HEADER } from '../../../../graphql/infogo-gql';
import useAuth from '../../../../hook/useAuth';
import { useFrench } from '../../../french/french-context';
import Button from '../../../common/button';

type HeaderUpdateProps = {
    orgId: string | null;
    header: IHeader | null;
    isOpen: boolean;
    toggle: () => void;
}

const HeaderUpdate = (props: HeaderUpdateProps) => {
    const { orgId, header, isOpen, toggle } = props
    const headerRef = useRef<HeaderHandler>(null)

    const [updateHeader, { loading }] = useMutation(UPDATE_HEADER)

    const [validated, setValidated] = useState<boolean>(true)

    const { isFrenchTranslator } = useAuth()
    const [frenchState] = useFrench()

    const saveHeader = () => {

        let headerInput = headerRef.current && headerRef.current.getHeader()

        updateHeader({
            variables: {
                headerId: header?.id,
                input: headerInput
            },
            refetchQueries: [{
                query: GET_INFOGO_HEADER_ORGS,
                variables: { orgId: orgId }
            }],
            awaitRefetchQueries: true,
            onError: (error) => {
                headerRef.current!.setError(error);
            },
            onCompleted: (data) => {
                toggle()
                data && notifySuccess()
            }
        })
    }

    const onChange = () => {
        if (frenchState.isFrenchChecked && isFrenchTranslator) setValidated(true)
        else setValidated(!!headerRef.current?.validate(false))
    }

    return (<>
        {loading && <SpinnerOverlay />}
        <Modal size="lg" isOpen={isOpen} toggle={toggle} scrollable backdrop="static" autoFocus={false}>
            <ModalHeader toggle={toggle} tag={'h2'}>Update a Header</ModalHeader>
            <ModalBody>
                <HeaderDetails ref={headerRef} header={header} onChange={onChange} autoFocus={true} />
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={saveHeader} disabled={!validated}><SaveIcon /> Update</Button>
                <Button color="secondary" onClick={toggle}><CancelIcon /> Cancel</Button>
            </ModalFooter>
        </Modal>
    </>
    )
}

export default HeaderUpdate
